// src/plugins/dialogConfirmacao.js
import Vue from 'vue';
import ConfirmDialog from '@/views/components/dialogConfirmacao.vue'; // Ajuste o caminho conforme necessário

const ConfirmDialogConstructor = Vue.extend(ConfirmDialog);

const confirmDialog = {
    install(Vue, { vuetify }) { // Recebe o Vuetify como argumento
        // Adiciona o método `$confirm` ao Vue
        Vue.prototype.$confirm = ({
            title,
            message,
            type,
            onConfirm,
            onCancel = () => { },
            confirmText = 'Confirmar',
            cancelText = 'Cancelar',
            tamanho = 500,
        }) => {
            const instance = new ConfirmDialogConstructor({
                propsData: {
                    title,
                    message,
                    type,
                    onConfirm,
                    onCancel,
                    confirmText,
                    cancelText,
                    tamanho,
                },
                vuetify, // Passa o Vuetify
            });

            // Monta a instância do componente
            instance.$mount();

            // Adiciona o componente ao body
            document.body.appendChild(instance.$el);

            // Abre o diálogo
            instance.open(); // Chama o método open
        };
    }
};

export default confirmDialog;
